<template>
	<svg
		width="12px"
		height="13px"
		viewBox="0 0 12 13"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-694.000000, -1917.000000)" fill="#FFFFFF">
				<g transform="translate(671.000000, 1882.000000)">
					<g transform="translate(12.000000, 24.000000)">
						<path
							d="M19.7662314,14.3246709 L23.4390226,21.2381601 C23.9572371,22.2136228 23.5865643,23.4244875 22.6111016,23.942702 C22.3221611,24.0962017 21.9999742,24.1764706 21.6727911,24.1764706 L14.3272089,24.1764706 C13.2226394,24.1764706 12.3272089,23.2810401 12.3272089,22.1764706 C12.3272089,21.8492875 12.4074778,21.5271006 12.5609774,21.2381601 L16.2337686,14.3246709 C16.7519831,13.3492083 17.9628478,12.9785354 18.9383105,13.49675 C19.2906951,13.6839543 19.5790271,13.9722863 19.7662314,14.3246709 Z"
							id="Triangle"
							transform="translate(18.000000, 17.588235) rotate(-270.000000) translate(-18.000000, -17.588235) "
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MediaPlayArrow',
}
</script>

<style lang="scss" scoped></style>
